module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_21.5e18913f.jpg";